import {Slider, Typography} from "@mui/material"
import {styled} from "@mui/material/styles"

export const PriceSliderLabel = styled(Typography)`
    margin-right: -1rem;
    font-family: ${({theme}) => `${theme.colours.font.secondary.regular.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.secondary.regular.weight};
`
export const PriceLabel = styled("span")`
    font-family: ${({theme}) => `${theme.colours.font.secondary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.secondary.medium.weight};
`

export const StyledSlider = styled(Slider)`
    color: ${({theme}) => theme.colours.text.default};
    & .MuiSlider-rail {
        height: 0.1875rem;
        opacity: 1;
        color: #c7c5c5;
    }

    & .MuiSlider-track {
        height: 0.1875rem;
    }

    & .MuiSlider-mark {
        background-color: #c7c5c5;
        height: 0.8125rem;
        width: 0.1875rem;
    }

    & .MuiSlider-markLabel {
        font-size: 0.875rem;
        color: ${props => props.theme.colours.text.default};
        font-family: ${({theme}) => `${theme.colours.font.secondary.medium.family}, ${theme.colours.font.default}`};
        font-weight: ${({theme}) => theme.colours.font.secondary.medium.weight};

        /* upper label */
        &[data-index="1"] {
            transform: translateX(calc(-100% + 0.5rem));
        }
    }

    & .MuiSlider-thumb {
        height: 1.5rem;
        width: 1.5rem;
        background-color: #fff;
        border: 0.125rem solid #c7c5c5;

        &:focus,
        &:hover,
        &:active,
        &.Mui-focusVisible {
            box-shadow: none;
        }

        &.Mui-focusVisible {
            outline: 2px solid ${({theme}) => theme.colours.palette.info.other.focusRingColor};
            outline-offset: 1px;
        }

        &::after {
            width: 0.5rem;
            height: 0.5rem;
            background-color: #000;
        }
    }
`
